import * as React from "react";
import {Icon} from "./Icon";

export class SynchronisationIcon extends Icon {

  render() {
    return <Icon {...this.props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path d="M6,27.37H17.25v2.25H10.16l.06.16a15.15,15.15,0,0,0,14,10A15.16,15.16,0,0,0,38.92,27.64l2.19.5A17.4,17.4,0,0,1,24.25,42a17.39,17.39,0,0,1-16-11.06h0v8.19H6ZM24.25,6a17.22,17.22,0,0,1,15.4,9.73l.11.22V7.71H42V19.5H30.75V17.25h7.12l-.24-.5a15,15,0,0,0-13.39-8.5A15.16,15.16,0,0,0,9.57,20.39L7.37,19.9A17.4,17.4,0,0,1,24.25,6Z" />
      </svg>
    </Icon>;
  }
}
